const manualWait = async (delay: number) => {
  return new Promise((res) => setTimeout(res, delay));
};

export default manualWait;
